export const replyDialogUserInput = async (apiCall, scopeId, dialog) => {
  const request = { item: dialog };
  const response = await apiCall(
    "/notification/userInput/reply",
    "POST",
    request,
    scopeId
  );
  return response && response.success;
};
